Namespace 'Customer.Ticket'

class Customer.Ticket.InstagramStickerView extends Backbone.View
  className: 'instagram-sticker'
  template: JST['backbone/templates/customer/ticket/sticker/instagram_sticker']

  initialize: (name) ->
    @svgPath = "#{name}.svg"
    @svgId = "#{name}-icon"
    @iconClass = "#{name} sticker-icon"
    @name = name


  events: ->
    _.extend(
      {},
      'click .sticker': 'triggerClick'
    )

  render: ->
    @$el.html(@template())
    @$el.find('.sticker').append(@createIcon().render().el)
    @

  createIcon: ->
    new Common.SvgIconView(
      svgPath: @svgPath
      svgId: @svgId
      iconClass: @iconClass
    )

  getName: ->
    @name

  triggerClick: ->
    @trigger 'sticker:clicked', @name
